import React, { useEffect } from "react";
import { observer } from "mobx-react";
import RootStore from "../stores/RootStore";
import SingleWidgetContainer from "./SingleWidgetContainer";
import OverlayWidgets from "./OverlayWidget";

const SingleOnMapContainer = observer(({ uiStore }) => {
  const {
    activeWidgetId,
    order,
    widgets,
    icons,
    widgetAreaWidth,
    setWidgetAreaWidth,
    widgetAreaHeight,
    setWidgetAreaHeight,
    setMoving,
    setResizing,
    resizing,
    moveListener,
    setMoveListener,
    moving,
    moveable,
    resizeListener,
    setResizeListener,
    widgetTop,
    widgetBottom,
    widgetLeft,
    widgetRight,
    setLeft,
    setBottom,
    setRight,
    setTop,
    buttonPosition = "top",
    resizeDirections,
  } = uiStore;

  // const reactResizable = { position: "relative" };

  const childWidgetCards = order.map((id, index) => {
    let widget = undefined;
    if (typeof widgets[id] === "function") {
      widget = widgets[id]();
    } else {
      widget = widgets[id];
    }
    return (
      <SingleWidgetContainer
        id={id}
        key={id + "onMapWidegt" + index}
        index={index}
        isActive={activeWidgetId === id}
        Icon={icons[id]}
        direction={"onMap"}
        uiStore={uiStore}
      >
        {widget}
      </SingleWidgetContainer>
    );
  });

  const handleResize = (evt) => {
    if (resizing) {
      const { startX, startY, direction } = resizing;
      const { pageX, pageY } = evt;
      const directions = direction.split("-");
      const preWidth = widgetAreaWidth;
      const preHeight = widgetAreaHeight;
      if (directions.indexOf("right") !== -1) {
        const finWidth = preWidth + (pageX - startX);
        setWidgetAreaWidth(finWidth);
        if (widgetRight) {
          setRight(widgetRight - (finWidth - preWidth));
        }
      } else if (directions.indexOf("left") !== -1) {
        const finWidth = preWidth - (pageX - startX);
        setWidgetAreaWidth(finWidth);
        if (widgetLeft) {
          setLeft(widgetLeft - (finWidth - preWidth));
        }
      }
      if (directions.indexOf("top") !== -1) {
        const finHeight = preHeight - (pageY - startY);
        setWidgetAreaHeight(finHeight);
        if (widgetTop) {
          setTop(widgetTop - (finHeight - preHeight));
        }
      } else if (directions.indexOf("bottom") !== -1) {
        const finHeight = preHeight + (pageY - startY);
        setWidgetAreaHeight(finHeight);
        if (widgetBottom) {
          setBottom(widgetBottom - (finHeight - preHeight));
        }
      }
    }
  };

  const handleMove = (evt) => {
    if (moving) {
      const { startX, startY } = moving;
      const { pageX, pageY } = evt;
      if (widgetTop !== undefined) {
        setTop(widgetTop + (pageY - startY));
      }
      if (widgetBottom !== undefined) {
        setBottom(widgetBottom + (startY - pageY));
      }
      if (widgetLeft !== undefined) {
        setLeft(widgetLeft + (pageX - startX));
      }
      if (widgetRight !== undefined) {
        setRight(widgetRight + (startX - pageX));
      }
    }
  };

  useEffect(() => {
    if (moving && !moveListener) {
      const listener = handleMove;
      const mouseUpListener = (evt) => setMoving(false);
      document.body.addEventListener("mousemove", listener);
      document.body.addEventListener("mouseup", mouseUpListener);
      setMoveListener({ listener, mouseUpListener });
    } else if (!moving && moveListener) {
      document.body.removeEventListener("mousemove", moveListener.listener);
      document.body.removeEventListener(
        "mouseup",
        moveListener.mouseUpListener
      );
      setMoveListener(null);
    }
    if (resizing && !resizeListener) {
      const listener = handleResize;
      const mouseUpListener = (evt) => {
        setResizing(false);
      };
      document.body.addEventListener("mousemove", listener);
      document.body.addEventListener("mouseup", mouseUpListener);
      setResizeListener({ listener, mouseUpListener });
    } else if (!resizing && resizeListener) {
      document.body.removeEventListener("mousemove", resizeListener.listener);
      document.body.removeEventListener(
        "mouseup",
        resizeListener.mouseUpListener
      );
      setResizeListener(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resizing, resizeListener, setWidgetAreaWidth, moving, moveListener]);
  const outerStyle = {
    width:
      activeWidgetId === "" &&
      (buttonPosition.includes("left") || buttonPosition.includes("right"))
        ? 0
        : widgetAreaWidth,
    height:
      activeWidgetId === "" &&
      (buttonPosition.includes("top") || buttonPosition.includes("bottom"))
        ? 0
        : widgetAreaHeight,
    position: "absolute",
    top: widgetTop,
    bottom: widgetBottom,
    left: widgetLeft,
    right: widgetRight,
  };
  // const directions = direction.split("-");
  const getResizeHandles = (direction) => {
    const directions = direction.split("-");
    if (directions.length > 1) {
      const reactResizableHandle = {
        position: "absolute",
        width: "20px",
        height: "20px",
        // bottom: 0,
        // right: 0,
        background:
          "url('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBzdGFuZGFsb25lPSJubyI/Pg08IS0tIEdlbmVyYXRvcjogQWRvYmUgRmlyZXdvcmtzIENTNiwgRXhwb3J0IFNWRyBFeHRlbnNpb24gYnkgQWFyb24gQmVhbGwgKGh0dHA6Ly9maXJld29ya3MuYWJlYWxsLmNvbSkgLiBWZXJzaW9uOiAwLjYuMSAgLS0+DTwhRE9DVFlQRSBzdmcgUFVCTElDICItLy9XM0MvL0RURCBTVkcgMS4xLy9FTiIgImh0dHA6Ly93d3cudzMub3JnL0dyYXBoaWNzL1NWRy8xLjEvRFREL3N2ZzExLmR0ZCI+DTxzdmcgaWQ9IlVudGl0bGVkLVBhZ2UlMjAxIiB2aWV3Qm94PSIwIDAgNiA2IiBzdHlsZT0iYmFja2dyb3VuZC1jb2xvcjojZmZmZmZmMDAiIHZlcnNpb249IjEuMSINCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHhtbDpzcGFjZT0icHJlc2VydmUiDQl4PSIwcHgiIHk9IjBweCIgd2lkdGg9IjZweCIgaGVpZ2h0PSI2cHgiDT4NCTxnIG9wYWNpdHk9IjAuMzAyIj4NCQk8cGF0aCBkPSJNIDYgNiBMIDAgNiBMIDAgNC4yIEwgNCA0LjIgTCA0LjIgNC4yIEwgNC4yIDAgTCA2IDAgTCA2IDYgTCA2IDYgWiIgZmlsbD0iIzAwMDAwMCIvPg0JPC9nPg08L3N2Zz4=')",
        backgroundPosition: "bottom right",
        backgroundRepeat: "no-repeat",
        backgroundOrigin: "content-box",
        boxSizing: "border-box",
        display: activeWidgetId !== "" ? "block" : "none",
      };
      if (
        directions.indexOf("right") !== -1 &&
        directions.indexOf("top") !== -1
      ) {
        reactResizableHandle.right = 0;
        reactResizableHandle.top = 0;
        reactResizableHandle.paddingTop = "3px";
        reactResizableHandle.paddingRight = "3px";
        reactResizableHandle.cursor = "ne-resize";
        reactResizableHandle.transform = "rotate(-90deg)";
      }
      if (
        directions.indexOf("right") !== -1 &&
        directions.indexOf("bottom") !== -1
      ) {
        reactResizableHandle.paddingRight = "3px";
        reactResizableHandle.paddingBottom = "3px";
        reactResizableHandle.right = 0;
        reactResizableHandle.bottom = 0;
        reactResizableHandle.cursor = "se-resize";
      }
      if (
        directions.indexOf("left") !== -1 &&
        directions.indexOf("top") !== -1
      ) {
        reactResizableHandle.left = 0;
        reactResizableHandle.paddingLeft = "3px";
        reactResizableHandle.paddingTop = "3px";
        reactResizableHandle.top = 0;
        reactResizableHandle.cursor = "nw-resize";
        reactResizableHandle.transform = "rotate(180deg)";
      }
      if (
        directions.indexOf("left") !== -1 &&
        directions.indexOf("bottom") !== -1
      ) {
        reactResizableHandle.left = 0;
        reactResizableHandle.paddingBottom = "3px";
        reactResizableHandle.paddingLeft = "3px";
        reactResizableHandle.bottom = 0;
        reactResizableHandle.cursor = "sw-resize";
        reactResizableHandle.transform = "rotate(90deg)";
      }
      reactResizableHandle.backgroundPosition = directions.join(" ");
      return (
        <div
          key={"resizeHandle" + direction}
          style={reactResizableHandle}
          onMouseDown={(evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const { pageX, pageY } = evt;
            setResizing({
              startX: pageX,
              startY: pageY,
              direction: direction,
            });
          }}
        ></div>
      );
    } else {
      const dragBarStyle = {
        display: activeWidgetId !== "" ? "block" : "none",
        position: "absolute",
        background: "grey",
        cursor: "col-resize",
      };
      if (direction === "left") {
        dragBarStyle.left = 0;
        dragBarStyle.marginLeft = "-5px";
        dragBarStyle.top = 0;
        dragBarStyle.bottom = 0;
        dragBarStyle.width = "5px";
      } else if (direction === "right") {
        dragBarStyle.right = 0;
        dragBarStyle.marginRight = "-5px";
        dragBarStyle.top = 0;
        dragBarStyle.bottom = 0;
        dragBarStyle.width = "5px";
      } else if (direction === "top") {
        dragBarStyle.top = 0;
        dragBarStyle.marginTop = "-5px";
        dragBarStyle.right = 0;
        dragBarStyle.left = 0;
        dragBarStyle.height = "5px";
        dragBarStyle.cursor = "row-resize";
      } else if (direction === "bottom") {
        dragBarStyle.bottom = 0;
        dragBarStyle.marginBottom = "-5px";
        dragBarStyle.right = 0;
        dragBarStyle.left = 0;
        dragBarStyle.height = "5px";
        dragBarStyle.cursor = "row-resize";
      }
      return (
        <div
          style={dragBarStyle}
          key={"ResizeHandle" + direction}
          onMouseDown={(evt) => {
            evt.preventDefault();
            evt.stopPropagation();
            const { pageX, pageY } = evt;
            setResizing({
              startX: pageX,
              startY: pageY,
              direction: direction,
            });
          }}
        />
      );
    }
  };

  const startMoveFunction = (evt) => {
    if (moveable) {
      const { pageX, pageY } = evt;
      setMoving({
        startX: pageX,
        startY: pageY,
      });
    }
  };

  // if (resizable === "full") {
  return (
    <div className="box" style={outerStyle} onMouseDown={startMoveFunction}>
      {childWidgetCards}
      {resizeDirections.map((direction) => getResizeHandles(direction))}
    </div>
  );
  // }

  // return <div style={outerStyle}>{childWidgetCards}</div>;
});

const OnMapWidgetContainer = observer(() => (
  <>
    {RootStore.uiStore.subUiStores["onMap"].map((subStore, index) => (
      <SingleOnMapContainer
        uiStore={subStore}
        key={"onMapWidgetContainer" + index}
      ></SingleOnMapContainer>
    ))}
    {<OverlayWidgets />}
  </>
));

export default OnMapWidgetContainer;
